import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import MitreText from './MitreText';
import MoreLikeThis from '../DocList/MoreLikeThis';

import { getDoc } from '../../services';

import Loading from '../DocList/Loading';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(fal);
const ReadMoreMitre = ({
  doc,
  profilePrimary,
  profileSecondary,
  list,
  allTags,
  updateTagSet,
  activeTags,
}) => {
  const [isReadMore, setIsReadMore] = useState(true);
  const [contents, setContents] = useState();
  const [contentsState, setContentsState] = useState(0);

  const toggleReadMore = async (tabIndex) => {
    if (isReadMore) {
      setIsReadMore(false);
      setContentsState(1);
      const result = await getDoc(
        doc.id,
        doc.repositoryId ?? null,
        profilePrimary
      );

      if (result.status === 200) {
        setContents(result.response);
        setContentsState(2);
      }
    } else {
      setContents('<span>Unable to fetch document.</span>');
      setContentsState(3);
      setIsReadMore(true);
    }
  };
  return (
    <section className='ctx-card-readmore'>
      <Button
        variant='text'
        onClick={toggleReadMore}
        className={
          isReadMore
            ? 'icon-only-button'
            : 'icon-only-button icon-only-button--open'
        }
      >
        <FontAwesomeIcon icon={['fal', 'caret-up']} />
      </Button>
      {contentsState && contentsState !== 3 ? (
        <div className='ctx-readmore-wrapper'>
          {contentsState === 1 && <Loading text='Retrieving More...' />}
          <div className='ctx-readmore-contents'>
            {contents && <MitreText text={contents} className='ctx-template' />}
          </div>
          {profileSecondary && (
            <MoreLikeThis
              docId={doc.id}
              profilePrimary={profilePrimary}
              profileSecondary={profileSecondary}
              list={list}
            />
          )}
        </div>
      ) : null}
    </section>
  );
};

export default ReadMoreMitre;
